// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__8Bjwu","title":"Header_title__2_Orr","left":"Header_left__pr68m","clinicName":"Header_clinicName__3Zeuu"};